module.exports = __webpack_public_path__ + "static/media/williamReed20.da0e8345.png";